import { createAsyncThunk } from '@reduxjs/toolkit';
import getCredentials from '../../utils/getCredentials';
import getResourcesWithEmail from 'scenes/ProjectForms/utils/getResourcesWithEmail';

export const loadResourcesWithEmail = createAsyncThunk(
    'projectForm/loadResourcesWithEmail',
    async (projectId, { getState }) => {
        const { accessKeyId, secretAccessKey, sessionToken } =
            await getCredentials();

        const params = {
            accessKeyId,
            secretAccessKey,
            sessionToken,
        };

        let getResourcesPromises = [];

        getResourcesPromises.push(getResourcesWithEmail(projectId, params));

        const getResourcesPromisesSettled = await Promise.allSettled(
            getResourcesPromises
        ).then((promises) => promises.map((promise) => promise.value));

        const resources = [].concat(...getResourcesPromisesSettled);

        return {
            resources,
        };
    }
);